import { render, staticRenderFns } from "./ORDsListSearchOptions.vue?vue&type=template&id=0dded1c3&scoped=true&"
import script from "./ORDsListSearchOptions.vue?vue&type=script&lang=js&"
export * from "./ORDsListSearchOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dded1c3",
  null
  
)

export default component.exports